/* eslint-disable @typescript-eslint/no-explicit-any */

import { omit } from 'lodash'

import { normalizeLineItem } from './LineItem'
import { convertIsoToString } from './utilities'

export const normalizeDeliveries = (item: any) => {
  if (!item) return item

  return {
    ...item,
    delivery_date: convertIsoToString(item.delivery_date)
  }
}

export const normalizeAddressSummary = (address: IAddress): string => {
  if (!address) return ''

  const combineStrings = (strings: string[], seperator = ' '): string =>
    strings.filter((i) => Boolean(i)).join(seperator)

  const { address: addressName, zip, city, country } = address

  return `${combineStrings([addressName, combineStrings([zip, city, country])], ', ')}`
}

export const normalizeDeliveryAddress = (address: IAddress): IDeliveryAddress => {
  if (!address) return undefined

  return {
    deliveryAddress1: address.address,
    deliveryAddress2: address.address2,
    deliveryZip: address.zip,
    deliveryCity: address.city,
    deliveryCountry: address.country
  }
}

export const normalizeProject = (project: IProject): IProject => {
  if (!project) return undefined

  return {
    ...project,
    display_address: normalizeAddressSummary(project.address),
    ...omit(project.address, ['address']) // remove address because of type mismatch
  }
}

export default function Rental(rental: any): IRental {
  if (rental) {
    return {
      ...rental,
      products: rental.products?.map(normalizeLineItem),
      deliveries: rental.deliveries?.map(normalizeDeliveries),
      addressSummary: normalizeAddressSummary(rental.deliveryAddress),
      delivery_address: normalizeAddressSummary(rental.deliveryAddress),
      ...normalizeDeliveryAddress(rental.deliveryAddress),
      start_date: convertIsoToString(rental.start_date),
      startDate: convertIsoToString(rental.start_date),
      return_date: convertIsoToString(rental.return_date),
      returnDate: convertIsoToString(rental.return_date),
      price_tax: rental.price_tax_total,
      price_total_with_deposit: rental.price_gross_total_with_deposit,
      price_to_pay: rental.totalPaid,
      project: normalizeProject(rental.project)
    }
  }
}
